import { scroll } from 'motion';

document.addEventListener( 'DOMContentLoaded', () => {
	// Target the features section
	const featuresSection = document.querySelector( '.features-section' );
	if ( ! featuresSection ) {
		console.log( 'Features section not found' );
		return;
	}

	const timelineLine = document.querySelector( '.timeline-line--features' );
	const timelineDot = document.querySelector( '.timeline-dot--features' );
	const featureItems = document.querySelectorAll( '.feature-item' );

	if ( ! timelineLine || ! timelineDot || ! featureItems.length ) {
		console.log( 'Timeline elements not found:', {
			timelineLine: !! timelineLine,
			timelineDot: !! timelineDot,
			featureItems: featureItems.length,
		} );
		return;
	}

	// Get the initial top position of the dot (should be 0)
	const dotInitialTop = 0;

	// Calculate the maximum position the dot can move to (bottom of the line minus dot height)
	const getMaxDotPosition = () => {
		const lineHeight = timelineLine.offsetHeight;
		const dotHeight = timelineDot.offsetHeight;
		return lineHeight - dotHeight;
	};

	// Create the scroll-linked animation
	scroll(
		( progress, info ) => {
			// Get viewport height
			const viewportHeight = window.innerHeight;

			// Calculate when the line enters and exits the middle of the viewport
			const lineRect = timelineLine.getBoundingClientRect();
			const lineTop = lineRect.top;
			const lineBottom = lineRect.bottom;
			const viewportMiddle = viewportHeight / 2;

			// Calculate how far the line has traveled relative to the middle of the viewport
			let dotPosition;

			// If the line hasn't reached the middle of the viewport yet
			if ( lineTop > viewportMiddle ) {
				dotPosition = dotInitialTop; // Keep dot at the top
			}
			// If the bottom of the line is above the middle of the viewport
			else if ( lineBottom < viewportMiddle ) {
				dotPosition = getMaxDotPosition(); // Keep dot at the bottom
			}
			// Line is passing through the middle of viewport - calculate position
			else {
				const totalLineTravel = lineRect.height;
				const lineProgress =
					( viewportMiddle - lineTop ) / totalLineTravel;
				dotPosition = lineProgress * getMaxDotPosition();
			}

			// Update the dot position
			timelineDot.style.top = `${ dotPosition }px`;

			// Add active class to features based on position
			featureItems.forEach( ( item, index ) => {
				const itemRect = item.getBoundingClientRect();
				const itemMiddle = itemRect.top + itemRect.height / 2;

				// Check if this item is near the dot position
				if (
					itemMiddle > viewportMiddle - 200 &&
					itemMiddle < viewportMiddle + 200
				) {
					item.classList.add( 'active' );
				} else {
					item.classList.remove( 'active' );
				}
			} );
		},
		{
			target: featuresSection,
		}
	);
} );
